"use client";

import HeaderGap from "@/components/atoms/headerGap";
import Container from "@/components/templates/container";
import Layout from "@/components/templates/layout";
import Spacer from "@/components/atoms/spacer";
import RectangleButton from "@/components/molecules/rectangleButton";
import CoverAnimation from "@/components/organisms/coverAnimation";
import Description from "./components/description";
import ButtonList from "./components/buttonList";
import FacilitesList from "./components/facilitiesList";
import { clientFetch } from "@/sanity/lib/client";
import { getFileAsset } from "@sanity/asset-utils";

const FacilitiesPage = ({ facilitiesAPI, footerAPI, settingAPI }) => {
  return (
    <Layout settingAPI={settingAPI} footerAPI={footerAPI}>
      <HeaderGap />
      <CoverAnimation
        option={facilitiesAPI.cover.option}
        images={facilitiesAPI.cover.images}
        video={facilitiesAPI.cover.video}
        imagePlaceholder={facilitiesAPI.cover.imagePlaceholder}
        aspectRatio={facilitiesAPI.cover.aspectRatio}
        rowOne={facilitiesAPI.cover.title.rowOne}
        rowTwo={facilitiesAPI.cover.title.rowTwo}
      />
      <Container outerClassName="mt-largeMobile lg:mt-largeDesktop">
        <Spacer />
        <div className="relative w-full flex flex-col justify-center items-center gap-y-mediumMobile lg:gap-y-mediumDesktop my-mediumMobile lg:my-mediumDesktop">
          <Description text={facilitiesAPI.description} />
          <ButtonList buttons={facilitiesAPI.facilitiesList} />
          <RectangleButton
            name={facilitiesAPI.ctaButton.name}
            link={
              facilitiesAPI.ctaButton.option === "link"
                ? facilitiesAPI.ctaButton.link
                : getFileAsset(
                    facilitiesAPI.ctaButton.pdf,
                    clientFetch.config()
                  ).url
            }
            target="_blank"
          />
        </div>
        <Spacer />
      </Container>
      <FacilitesList facilitiesList={facilitiesAPI.facilitiesList} />
    </Layout>
  );
};

export default FacilitiesPage;
